import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from '../../LanguageContext';
import styles from './Shorts.module.css';

const LazyYoutubeEmbed = ({ videoId, index }) => {
  const ref = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  // ScrollReveal effect
  useEffect(() => {
    if (ref.current) {
      const element = ref.current;
      
      element.style.opacity = '0';
      element.style.transform = 'translateY(30px) scale(0.95)';
      element.style.transition = 'all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              element.style.opacity = '1';
              element.style.transform = 'translateY(0) scale(1)';
            }, index * 100);
            observer.unobserve(element);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });
      
      observer.observe(element);
      
      return () => observer.disconnect();
    }
  }, [index]);

  if (isPlaying) {
    return (
      <div className={styles.shortItem} ref={ref}>
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}?loop=1&controls=1&rel=0&autoplay=1`}
          title={`Video ${index + 1}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className={styles.iframe}
        />
      </div>
    );
  }

  return (
    <div className={styles.shortItem} ref={ref}>
      <div className={styles.thumbnail} onClick={() => setIsPlaying(true)}>
        <img
          src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
          alt={`YouTube Video ${index + 1}`}
          loading="lazy"
          className={styles.thumbnailImage}
          onError={(e) => {
            e.target.src = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
          }}
        />
        <div className={styles.playButton}></div>
      </div>
    </div>
  );
};

const NarkisMore = () => {
  const { t } = useTranslation();
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  
  const videosData = [
    'zhsOQgdodZE',
    'aUpjGu4UNrQ',
    'w3aa1eXxS1c',
    'H1QJj8D9ilk',
  ];

  useEffect(() => {
    if (titleRef.current) {
      const element = titleRef.current;
      
      element.style.opacity = '0';
      element.style.transform = 'translateY(-20px)';
      element.style.transition = 'all 0.8s cubic-bezier(0.23, 1, 0.320, 1)';
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              element.style.opacity = '1';
              element.style.transform = 'translateY(0)';
            }, 200);
            observer.unobserve(element);
          }
        });
      }, {
        threshold: 0.5
      });
      
      observer.observe(element);
      
      return () => observer.disconnect();
    }
  }, []);

  useEffect(() => {
    if (descriptionRef.current) {
      const element = descriptionRef.current;
      
      element.style.opacity = '0';
      element.style.transform = 'translateY(-15px)';
      element.style.transition = 'all 0.8s cubic-bezier(0.23, 1, 0.320, 1)';
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              element.style.opacity = '1';
              element.style.transform = 'translateY(0)';
            }, 400);
            observer.unobserve(element);
          }
        });
      }, {
        threshold: 0.5
      });
      
      observer.observe(element);
      
      return () => observer.disconnect();
    }
  }, []);

  return (
    <div className={styles.container} id="מגזינים">
      <h2 className={styles.title} ref={titleRef}>
        {t.shorts.title}
      </h2>
      <p className={styles.description} ref={descriptionRef}>
        {t.shorts.description}
      </p>
      <div className={styles.videosContainer}>
        {videosData.map((videoId, index) => (
          <LazyYoutubeEmbed 
            key={index} 
            videoId={videoId} 
            index={index} 
          />
        ))}
      </div>
    </div>
  );
};

export default NarkisMore;